<div id="toolbar-background" fxLayout="row" fxLayoutAlign="start center">
  <button
    mat-mini-fab
    class="mr-20"
    *ngIf="showBackButton"
    title="Back"
    color="primary"
    (click)="goBack()"
  >
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span ngClass.gt-xs="font-size-15" ngClass.lt-sm="font-size-12">
    {{ heading }}
  </span>
</div>
